import api from './api';

const getAll = (pagination, filter, sortColumn) => api.get('/province', {
    pageNum: pagination.currentPage - 1, 
    pageLength: pagination.itemsPerPage, 
    active: filter.active,
    search: filter.search,
    sortBy: sortColumn.sortByColumn,
    orderBy: sortColumn.orderBy
}).then(response => response.data);

const getList = () => api.get('/province/list').then(response => response.data);

const create = (data) => api.post('/province', data).then(response => {
    return response.data
});

const getById = (id) => api.get(`/province/${id}`).then(response => response.data);

const update = (id, data) => api.put(`/province/${id}`, data).then(response => {
    return response.data
});

const remove = (id) => api.delete(`/province/${id}`).then(response => {
    return response.data
});

const ProvinceService = {
    getAll,
    getList,
    getById,
    create,
    remove,
    update
}

export default ProvinceService;